import { addError } from '../../packs/tracing';

function handleError(error) {
  console.log(`Failed to update user settings; Reason: ${error.message}`);
  addError('user-settings', error);
}

async function doUpdateFeature(key, value) {
  const csrfToken = getCsrfToken();
  const response = await fetch('/account/settings', {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': csrfToken,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({feature: key, value}),
  });

  if (response.ok) {
    return;
  }

  switch (response.status) {
    case 403:
      location.href = '/login';
      break;
    default:
      const error = new Error();
      error.message = `Status code: ${response.status}`;
      throw error;
  }
}

export function updateFeature(key, value) {
  doUpdateFeature(key, value)
    .then(_data => {
      const event = new CustomEvent('nv.feature.toggled', {
        detail: {
          key,
          value
        }
      });
      document.dispatchEvent(event);
    })
    .catch(handleError);
}
